import React, { useEffect, useContext, useState } from 'react'
import PageHeader from '../helper/PageHeader';
import { useHistory, useParams } from 'react-router'
import SimpleTable from '../helper/SimpleTable';
import {AddCreditDialog} from '../helper/Dialogs';
import { authContext } from '../../context/AuthContext';
import {EnterRefundDetails} from '../helper/Dialogs';
import { trainingCost } from '../../constants/global'

import Loading from '../helper/Loading';
import axios from 'axios';

const tableCells = [
    { id: 'createDate', label: 'Date', centered: false },
    { id: 'actionText', label: 'Add/Deduct', centered: false },
    { id: 'amount', label: 'Amount', centered: false },
    { id: 'notes', label: 'Notes', centered: false },
    { id: 'createdByUsername', label: 'By', centered: false },
    { id: 'originalTransactionID', label: 'Original Transaction ID', centered: false },
    { id: 'processedDate', label: 'Date Processed', centered: false },
    { id: 'voucherID', label: 'Voucher ID', centered: false },
];

const AdminUserCredit = props => {
    const history = useHistory()   
    const params = useParams()
    const context = useContext(authContext)

    const [availableCredit, setAvailableCredit] = useState(null);
    const [name, setName] = useState(null);
    const [data, setData] = useState(null);
    const [addCredit, setAddCredit] = useState({open: false, amount: trainingCost, notes: 'Courtesy Credit from GI-BMP Office'})
    const [refundDetails, setRefundDetails] = useState({ processedDate:'', voucherID:'', ID: '' })

    async function getData() {
        const res = await axios.all([
            axios.get('/api/user/credit/'+ params.username, {}),
            axios.get('/api/credit/log/'+ params.username, {})
        ])
        console.log('res data', res);

        res[1].data.forEach(e => {
          e.actionsDisabled = {
            allowRefund: (e.action === 'R' )
           }
           console.log('res[1] data', res[1].data);
        });

        setData(res[1].data);
        console.log('data', data);
        setAvailableCredit(res[0].data.user.credit)
        setName(res[0].data.user.first_name + ' ' + res[0].data.user.last_name)
    }

    useEffect(() => {
       
        getData();
    // render only once
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    // opens add credit dialog
    const onAddCreditDialogOpen = () => {
        console.log("onAddCredit");
        setAddCredit({open: true,  amount: trainingCost, notes: 'Courtesy Credit from GI-BMP Office'})
        console.log(addCredit.open);
    }

    // closes dialog
    const onAddCreditDialogClose = () => {
        setAddCredit({open: false, amount: trainingCost, notes: 'Courtesy Credit from GI-BMP Office'})
    }

    // submits credit additions and reload
    const handleAddCredit = async () => {
        let byUserName = context.user.username;
        let token = context.accessToken;

        let data = {
            amount:parseInt(addCredit.amount),
            notes: addCredit.notes,
            byUsername: byUserName
        }

        console.log(data);
        await axios('/api/credit/add/user/' + params.username, {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        })
       // reloads user credit log
        getData()

        onAddCreditDialogClose()
    }

    // handles textfield update for notes
    const handleNotes = (event) => {
        event.persist()
        setAddCredit( prev => {return {...prev, notes: event.target.value}})
    }

    // handles textfield update for amount
    const handleAmount = (event) => {
        event.persist()
        setAddCredit( prev => {return {...prev, amount: event.target.value}})
    }

    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
      setOpen(true);
    };
  
    const handleClose = () => {
      setOpen(false);
    };

    const onRefundUpdate = async (id) => {
        const creditLog = data.find(e => e.ID === id)
        console.log(creditLog);
        if(creditLog.action === 'R'){
            setRefundDetails( prev => {return {...prev, ID: creditLog.ID, processedDate: creditLog.processedDate, voucherID:creditLog.voucherID  }})
            console.log(refundDetails);
            handleClickOpen();
        } 

    }

    const handleDateProcessed = (event) => {
        event.persist()
        setRefundDetails( prev => {return {...prev, processedDate: event.target.value}})
        console.log('date processed', refundDetails.processedDate);
    }

    const handleVoucherID = (event) => {
        event.persist()
        setRefundDetails( prev => {return {...prev, voucherID: event.target.value}})
        console.log('voucher id', refundDetails.voucherID);
    }

    const handleRefundClick = async () => {
        
        console.log('data to be sent to server', refundDetails );

        let token = context.accessToken;

        let data = {
            voucherID: refundDetails.voucherID,
            processedDate: refundDetails.processedDate

        }

        console.log(data);
        await axios('/api/credit/log/' + refundDetails.ID , {
            method: 'POST',
            data: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            }
        })
       // reloads user credit log
       console.log("closing dialog");
       handleClose()
        getData()


        
    }

    const actionButtons = [
        { label: 'Update', action: onRefundUpdate, delete: false, view: "allowRefund"  },
    ];


    return (
        <>
            <PageHeader title={params.username + " Purchase History" }
                cancel={history.goBack} 
                actionButtons={[{ label: "Free Credit", action: onAddCreditDialogOpen }]}
            />
            <p>Name: {name}</p>
            <p>Available Credit: {availableCredit}</p>
            <AddCreditDialog
                open={addCredit.open}
                amount={addCredit.amount}
                notes={addCredit.notes}
                onAddCredit={handleAddCredit}
                onAmountChange={handleAmount}
                onNotesChange={handleNotes}
                onClose={onAddCreditDialogClose}
            />
            {data === null ? <Loading /> :
                data.length === 0 ? <h1>No purchase history found</h1> :
                    <>
                        <EnterRefundDetails 
                        open={open}
                        processedDate={refundDetails.processedDate}
                        voucherID={refundDetails.voucherID}
                        onClose={handleClose}
                        onDateChange = {handleDateProcessed}
                        onVocherChange = {handleVoucherID}
                        onRefundClick = {handleRefundClick}
                        />
                        <SimpleTable
                            data={data}
                            cellKey={"ID"}
                            tableCells={tableCells}
                            actionButtons={actionButtons}
                            actions={true}
                        />
                    </>
            }

        </>
    )
}

export default AdminUserCredit;